import { apiRequest } from "./apiClient";
import { currentTimeZonePayload } from "../hooks/useUserTimezone";

const normalizeScheduledDateForStorage = (value) => {
  if (!value) return "";
  const date = value?.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
};

const normalizeId = (value) => {
  if (!value) return null;
  return String(value).replace(/[^a-zA-Z0-9_-]/g, "_");
};

export const localScheduleFields = (value) => {
  if (!value) return { localDate: null, localTime: null };
  const date = value?.toDate ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return { localDate: null, localTime: null };
  return {
    localDate: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`,
    localTime: `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`,
  };
};

/**
 * Kullanıcı/aile/sistem zamanlı bildirimlerini artık Firestore yerine backend'e yazar.
 * Backend due olduğunda aynı kaydı hem push/native hem de bildirim merkezi için işler.
 */
export async function zamanliBildirimOlustur({
  hedefTipi = "users",
  hedefUidler = [],
  hedefSayisi = null,
  baslik,
  aciklama,
  baslikKey = null,
  baslikVars = null,
  aciklamaKey = null,
  aciklamaVars = null,
  baslikI18n = null,
  aciklamaI18n = null,
  planlananTarih,
  tekrarTipi = "none",
  tip = "scheduledAdmin",
  bildirimTipi = "scheduled",
  bildirimType = null,
  kaynak = "scheduledNotification",
  kaynakId = null,
  kaynakTuru = null,
  olusturanUid,
  familyId = null,
  url = "/",
  idempotencyKey = null,
  extraData = null,
}) {
  const safeKey = idempotencyKey ? normalizeId(idempotencyKey) : null;
  const safeExtraData = extraData && typeof extraData === "object" && !Array.isArray(extraData) ? extraData : {};
  const localFields = localScheduleFields(planlananTarih);
  const zone = currentTimeZonePayload();

  const payload = {
    ...safeExtraData,
    hedefTipi,
    hedefUidler: Array.isArray(hedefUidler) ? hedefUidler.filter(Boolean) : [],
    hedefSayisi,
    baslik,
    aciklama,
    baslikKey,
    baslikVars,
    aciklamaKey,
    aciklamaVars,
    baslikI18n,
    aciklamaI18n,
    planlananTarih: normalizeScheduledDateForStorage(planlananTarih),
    scheduleMode: "recipient_local",
    ...localFields,
    scheduleTimezone: zone.timeZone,
    tekrarTipi: tekrarTipi || "none",
    tip,
    bildirimTipi,
    bildirimType: bildirimType || null,
    kaynak,
    kaynakId,
    kaynakTuru,
    durum: "bekliyor",
    olusturanUid,
    familyId,
    url,
    idempotencyKey: safeKey,
  };

  const data = await apiRequest("/notifications/scheduled", {
    method: "POST",
    body: JSON.stringify(payload),
  });

  return data?.id || data?.item?.id || safeKey;
}
